import Modal from '@ubnt/ui-components/Modal/Modal';
import Text from '@ubnt/ui-components/Text/Text';
import InfoIndicator from '@ubnt/link-core-ui/components/InfoIndicator/InfoIndicator';

const RestrictedCountryDialog = () => (
  <Modal title="Restricted area" headerIcon={<InfoIndicator severity="warning" size="large" />} size="small" isOpen>
    <Text size="body">{import.meta.env.VITE_TITLE} features are not available in your location.</Text>
  </Modal>
);

export default RestrictedCountryDialog;
